// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__VMMTF","col":"styles_col__2ezaA"};